import * as React from 'react';
import PXLSelect from 'components/PXL/pxlSelect';
import Modal from 'components/common/modal';
import strings from 'utils/strings';
import { killEvent } from 'utils/domUtils';
import './switchAccountsModal.scss';

interface SwitchAccountsModalProps {
    accounts: MasterAccountDictionary;      // map of accounts this user has access to
    currentAccountId: string;               // currently selected account id
    onCommit?: (accountId: string) => void; // callback to notify parent of commit of dialog/value
    onHide?: () => void;                    // callback to notify parent when modal hidden
    show: boolean;                          // whether or not to make the modal visible
}

// exported for testing
export interface SwitchAccountsModalState {
    selectedAccount: string;                // currently selected account (not yet committed)
    visible: boolean;                       // whether or not modal is currently visible
}

// Modal which present user with a list of accounts they have access to,
// allowing them to make a new one active
class SwitchAccountsModal extends React.PureComponent<SwitchAccountsModalProps, SwitchAccountsModalState> {
    constructor(props: SwitchAccountsModalProps) {
        super(props);
        this.state = Object.assign(
            {},
            this.state,
            {
                selectedAccount: props.currentAccountId,
                visible: props.show
            }
        );

        // bind all our event handlers
        this._hide = this._hide.bind(this);
        this._onAccountChange = this._onAccountChange.bind(this);
        this._onCommit = this._onCommit.bind(this);
    }

    // sync our internal state with props
    UNSAFE_componentWillReceiveProps(nextProps: SwitchAccountsModalProps): void {
        this.setState({
            selectedAccount: nextProps.currentAccountId,
            visible: nextProps.show
        });
    }

    render(): React.ReactNode {
        const { accounts } = this.props;
        const { visible, selectedAccount } = this.state;

        const accountOptions = Object.keys(accounts)
            .sort((accountAId: string, accountBId: string) => {
                return accounts[accountAId].name.localeCompare(accounts[accountBId].name);
            }).map(accountId => {
                const account = accounts[accountId];
                return {text: account.name, value: account.id};
            });

        return (
            <Modal className="switch-accounts-modal" show={visible} onHide={this._hide} >
                <h2 className="switch-accounts-modal__title">{strings.switchAccountsTitle}</h2>
                <div className="switch-accounts-modal__sub-title">{strings.switchAccountsSubTitle}</div>
                <PXLSelect
                    options={accountOptions}
                    className="switch-accounts-modal__account-selector"
                    onChange={this._onAccountChange}
                    value={selectedAccount}
                />
                <div className="modal__button-container">
                    <a className="modal__cancel-link" href="#" onClick={this._hide}>{strings.cancel}</a>
                    <button
                        className="pxl-btn pxl-btn-primary modal__ok-button"
                        onClick={this._onCommit}
                    >
                        {strings.continue}
                    </button>
                </div>
            </Modal>
        );
    }

    private _hide(e?: React.SyntheticEvent<HTMLAnchorElement>): void {
        if (e) {
            killEvent(e);
        }
        this.setState({
            visible: false
        });

        const { onHide } = this.props;
        if (onHide) {
            onHide();
        }
    }

    // Handler for changes to account selector, updating our state
    // as the component isn't controlled
    private _onAccountChange(_: string, value: string): void {
        this.setState({
            selectedAccount: value
        });
    }

    private _onCommit(): void {
        const { onCommit } = this.props;
        const { selectedAccount } = this.state;
        if (onCommit) {
            onCommit(selectedAccount);
        }
        this._hide();
    }
}

export { SwitchAccountsModal };
export default SwitchAccountsModal;



// WEBPACK FOOTER //
// ./src/components/switchAccountsModal.tsx